<!--suppress XmlInvalidId -->
<template>
  <ws-modal-dialog :on-close="handleClose" focused="email">
    <div class="modal-header">
      <span class="modal-title" id="exampleModalLabel">Need Help?</span>
      <button @click="closeModal" type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="text-center">
        <div class="alert alert-warning modal-alert">
          The more details we have the faster and better we can resolve your issue.
        </div>
        <form role="form">
          <div class="form-group">
            <label for="email">Your Username or Email</label>
            <ws-text-input v-model="email" name="email" field="email" id="email"/>
          </div>
          <div class="form-group">
            <label for="body">Enter Support Question</label>
            <ws-text-area-input v-model="body" name="body" field="body"/>
          </div>
          <!-- The id for popup dailog buttons must be unique to the application -->
          <ws-signal-button id="login-support-submit-btn" class="btn btn-primary modal-submit" text="Submit"
                            data-dismiss="modal"
                            :disabled="!canSubmit()" :aria-disabled="!canSubmit()"
                            :onSubmit="handleSubmit"/>
        </form>
        <p class="m-t text-muted">
          <small>&copy; {{ copyright }}</small>
        </p>      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger btn-sm modal-close" @click="closeModal" data-dismiss="modal">Close
      </button>
    </div>
  </ws-modal-dialog>
</template>

<script>
import WsModalDialog from '@/views/dialog/ModalDialog'
import ApiService from '@/common/api.service'

export default {
  name: 'LoginSupportRequest',
  data () {
    return {
      email: '',
      body: ''
    }
  },

  methods: {
    canSubmit () {
      return this.email !== '' && this.body !== ''
    },

    closeModal () {
      this.$parent.$emit('closeLoginSupportRequest')
    },

    handleSubmit () {
      const appName = process.env.APP_NAME
      // Save data
      ApiService
        .post('admin/email/support/notice', {
          email: this.email,
          subject: `[${appName}] Support Request From: ${this.email}`,
          priority: 'high',
          body: this.body
        })
    },

    handleClose () {
      this.closeModal()
    }
  },

  computed: {
    copyright () {
      return process.env.COPYRIGHT
    }
  },

  components: {
    WsModalDialog
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/support/LoginSupportRequest.vue